@let conversations =
  assistantGroup.conversation.plugins.currentListPlugin.feature.selectors.entities.asSignal();
@let selectedConversationId =
  assistantGroup.conversation.plugins.currentEntityPlugin.feature.selectors
    .getId()
    .asSignal();
@let conversationLoading =
  assistantGroup.conversation.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();

@let conversationToEdit =
  assistantGroup.conversation.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@let conversationToEditName = conversationToEdit?.name;

@let conversationToDelete =
  assistantGroup.conversation.plugins.editingPlugin.feature.selectors
    .deletedEntities()
    .asSignal()[0];

<aside class="dolomite-chat__sidebar">
  <div class="dolomite-chat__sidebar-header">
    <h3 class="dolomite-chat__sidebar-title">
      <i class="atn-icon atn-comment atn-blue"></i>
      <span>Conversations</span>
    </h3>
    <button
      class="dolomite-chat__new-chat-btn"
      type="button"
      title="New conversation"
      (click)="selectConversation(undefined)"
    >
      <i class="atn-icon atn-plus atn-blue"></i>
    </button>
  </div>

  <div class="dolomite-chat__conversation-list">
    @if (conversationLoading) {
      <div class="dolomite-chat__conversation-list-loading">
        <atn-ds-loader type="typing" />
      </div>
    } @else {
      @for (conversation of conversations; track conversation.id) {
        <button
          class="dolomite-chat__conversation-item"
          [class.dolomite-chat__conversation-item--active]="
            conversation.id === selectedConversationId
          "
          (click)="selectConversation(conversation.id)"
          type="button"
        >
          <span class="dolomite-chat__conversation-item-label">{{
            conversation.name
          }}</span>
          <div class="dolomite-chat__conversation-item-actions">
            <i
              class="atn-icon atn-edit dolomite-chat__conversation-item-edit"
              [class.atn-blue]="conversation.id !== selectedConversationId"
              [class.atn-light]="conversation.id === selectedConversationId"
              title="Edit conversation"
              (click)="editConversation(conversation.id, $event)"
            ></i>
            <i
              class="atn-icon atn-trash dolomite-chat__conversation-item-delete"
              [class.atn-red]="conversation.id !== selectedConversationId"
              [class.atn-light]="conversation.id === selectedConversationId"
              title="Delete conversation"
              (click)="deleteConversation(conversation.id, $event)"
            ></i>
          </div>
        </button>
      } @empty {
        <div class="dolomite-chat__conversation-list-empty">
          <p>No conversations yet</p>
        </div>
      }
    }
  </div>
</aside>

@if (
  assistantGroup.conversation.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Delete Conversation"
    [description]="
      'Are you sure you want to delete <b>' +
      conversationToDelete.name +
      '</b>? This action cannot be undone.'
    "
    [validation]="conversationToDelete.name"
    (cancel)="cancelDeleteConversation()"
    (confirm)="confirmDeleteConversation()"
    [loading]="
      assistantGroup.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
    "
    confirmButtonText="Delete"
  />
}

@if (conversationToEdit) {
  <atn-ds-centered-overlay>
    <atn-ds-widget title="Update Conversation">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelEditConversation()"
      ></i>
      <div class="dolomite-chat__edit-dialog-content">
        <atn-ds-text
          label="Name"
          placeholder="Enter conversation name"
          [value]="conversationToEditName"
          (change)="updateConversationName($event ?? '')"
        ></atn-ds-text>
      </div>
      <div
        footer
        class="dolomite-chat__edit-dialog-footer"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelEditConversation()"
          [disabled]="
            assistantGroup.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
          "
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveConversation()"
          [loading]="
            assistantGroup.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
          "
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
